import { GEO } from '../../../core/constants/geo';

export default class ListNearbyPosts {
  constructor(postRepository) {
    this.postRepository = postRepository;
  }

  /**
   * Récupère les posts à proximité d'une localisation donnée
   * @param {Object} params Paramètres de recherche
   * @param {Object} params.location Coordonnées de l'utilisateur {latitude, longitude}
   * @param {number} params.maxDistanceKm Distance maximale en kilomètres
   * @param {number} params.limit Nombre maximum de résultats à retourner
   * @param {string} params.excludeUserId ID de l'utilisateur à exclure des résultats
   * @param {boolean} params.refresh Force le rafraîchissement des données
   * @returns {Promise<Object>} Résultats de la recherche
   */
  async execute({ 
    location, 
    maxDistanceKm = GEO.DEFAULT_RADIUS_KM,
    limit = 20, 
    excludeUserId = null,
    refresh = false
  } = {}) {
    try {
      // Vérifier si la localisation est valide
      if (!location || !location.latitude || !location.longitude) {
        throw new Error('La localisation est requise pour cette recherche');
      }

      // Appeler le repository avec les paramètres de géolocalisation
      const result = await this.postRepository.getNearbyPosts({
        center: {
          latitude: location.latitude,
          longitude: location.longitude
        },
        radiusInKm: maxDistanceKm,
        limit,
        excludeUserId,
        refresh
      });

      return {
        posts: result.posts,
        hasMore: result.hasMore
      };
    } catch (error) {
      throw error;
    }
  }
} 